var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "job-listing--item-footer" },
    [
      _vm.hasMatches && _vm.isPublished
        ? _c(
            "a",
            {
              staticClass: "matches",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("load")
                }
              }
            },
            [
              _c("Icon", { attrs: { icon: "heart", color: "primary" } }),
              _vm._v(" " + _vm._s(_vm.matches) + "\n\t")
            ],
            1
          )
        : _c(
            "span",
            { staticClass: "matches" },
            [
              _c("Icon", { attrs: { icon: "heart" } }),
              _vm._v(" " + _vm._s(_vm.matches) + "\n\t")
            ],
            1
          ),
      _vm._v(" "),
      _vm.isQuestionnaireFinished
        ? _c(
            "a",
            {
              class: ["status", { published: _vm.isPublished }],
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.clickedPublishInfo.apply(null, arguments)
                }
              }
            },
            [
              _c("Icon", {
                attrs: { icon: _vm.isPublished ? "checkmark" : "close" }
              }),
              _vm._v(
                "\n\t\t" +
                  _vm._s(
                    _vm.isPublished
                      ? "Anonym veröffentlicht"
                      : "Noch nicht veröffentlicht"
                  ) +
                  "\n\t"
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.publish
        ? _c("PublishPopUp", {
            attrs: {
              "job-profile": _vm.jobProfileListItem.jobProfile,
              "publishable-checklist":
                _vm.jobProfileListItem.publishableChecklist
            },
            on: {
              hidden: function($event) {
                _vm.publish = false
              },
              publish: _vm.onPublish
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.unpublish
        ? _c("UnpublishPopUp", {
            attrs: { "job-profile": _vm.jobProfileListItem.jobProfile },
            on: {
              hidden: function($event) {
                _vm.unpublish = false
              },
              unpublish: _vm.onUnpublish
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }